import LoginTest from './main.js';

export default function (to, from, next) {

    LoginTest.check(next, {
      type: ['login']             // []空数组或者false：只获取签名，['auth']：微信授权，['login']：登录
      , redirectUrl: '/login' 
    }, to, from)
    // .then((res)=>{
		//   console.log(res, 999999999999999999)
    // })

}


// WEBPACK FOOTER //
// ./src/auth/index.js